import { useEffect, useState, useCallback } from "react";
import { Bot, DollarSign, CheckCircle } from "lucide-react";
import { api } from "../lib/api";
import { eventBus } from "../lib/eventBus";
import { fmtCost } from "../lib/format";
import type { Stats, WSMessage } from "../lib/types";

export function TopMetrics() {
  const [stats, setStats] = useState<Stats | null>(null);
  const [cost, setCost] = useState<number | null>(null);

  const load = useCallback(async () => {
    try {
      const [statsRes, costRes] = await Promise.all([api.stats.get(), api.pricing.totalCost()]);
      setStats(statsRes);
      setCost(costRes.total_cost);
    } catch {
      // silently fail
    }
  }, []);

  useEffect(() => {
    load();
    const interval = setInterval(load, 15000);
    return () => clearInterval(interval);
  }, [load]);

  useEffect(() => {
    return eventBus.subscribe((msg: WSMessage) => {
      if (
        msg.type === "agent_created" ||
        msg.type === "agent_updated" ||
        msg.type === "session_created" ||
        msg.type === "session_updated"
      ) {
        load();
      }
    });
  }, [load]);

  return (
    <div className="flex items-center gap-6 text-xs">
      <div className="flex items-center gap-1.5">
        <Bot className="w-3.5 h-3.5 text-emerald-400" />
        <span className="text-gray-400">{stats?.active_agents ?? 0} activos</span>
      </div>
      <div className="flex items-center gap-1.5">
        <DollarSign className="w-3.5 h-3.5 text-emerald-400" />
        <span className="text-gray-400">{cost !== null ? fmtCost(cost) : "$0.00"} hoy</span>
      </div>
      <div className="flex items-center gap-1.5">
        <CheckCircle className="w-3.5 h-3.5 text-accent" />
        <span className="text-gray-400">{stats?.events_today ?? 0} eventos</span>
      </div>
    </div>
  );
}
